import React from 'react'
import dayjs from '../../../../dayjsConfig'
import { darkBlue, darkerGreen, darkGreen, primaryBlue } from '../../../../styles/material-ui-theme-v2'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { ConsistencyProgress, IYumConsistencyPillsProps } from './YumConsistencyPills'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: '10px',

    /*gap: '4px',
    '@media (min-width: 375px)': {
      gap: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      //'@include respond-above(sm)': {
      gap: '6px',
    },*/

    overflowX: 'scroll',
    overflowY: 'visible',

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  day: (props: IYumConsistencyPillsProps) => ({
    width: '100%',
    height: '6px',
    backgroundColor: props.darkBg ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.18)',
    //opacity: 0.1,
    borderRadius: '2px',
    flexBasis: '100%',
    minWidth: '4px',
    marginRight: '4px',
    '@media (min-width: 375px)': {
      minWidth: '5px',
      marginRight: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: '6px',
      marginRight: '6px',
    },
    'html[dir=ltr] &:last-child': {
      marginRight: '0px !important',
    },
    'html[dir=rtl] &:first-child': {
      marginRight: '0px !important',
    },
  }),
  unmet: (props: IYumConsistencyPillsProps) => ({
    backgroundColor: props.darkBg ? '#C97A7A' : '#9E4F4F',
  }),
  current: (props: IYumConsistencyPillsProps) => ({
    backgroundColor: props.darkBg ? '#E6EBF5' : '#0D1F50',
  }),
  met: (props: IYumConsistencyPillsProps) => ({
    backgroundColor: props.darkBg ? '#6FC6A4' : '#1F5F4B',

    // '&$current': {
    //   backgroundColor: darkerGreen,
    // },
  }),
}))

export default function YumConsistencyPillsCompact(props: IYumConsistencyPillsProps) {
  const classes = useStyles(props)

  // Default isParticipating to true for backward compatibility
  const isParticipating = props.isParticipating !== false

  const dayBEM = ({ date, achieved }: ConsistencyProgress) => {
    const base = classes.day
    const classArray = [base]
    const isToday = dayjs().locale('en').format('YYYY-MM-DD') === date
    const isPast = dayjs(date).isBefore(new Date())

    if (!isParticipating && (isToday || isPast)) {
      // Not participating — show all past/current days as neutral (white)
      classArray.push(classes.current)
    } else {
      if (isToday || isPast) {
        classArray.push(achieved ? classes.met : classes.unmet)
      }

      if (isToday) {
        classArray.push(classes.current)
      }
    }

    return classArray.join(' ')
  }

  return (
    <div className={classes.wrapper}>
      {props.progress.map((day: ConsistencyProgress, keyIndex) => {
        return <div title={day.date} className={dayBEM(day)} key={keyIndex} />
      })}
    </div>
  )
}
